import { createFileRoute } from '@tanstack/react-router';
import { ErrorLogDetailRoute } from '@/pages/error-logs/detail-route';

/** Deep link al dettaglio: la vista sta già sotto, montata dal layout. */
export const Route = createFileRoute('/admin/_layout/error-logs/_layout/$id')({
  component: ErrorLogDetailRouteComponent,
});

function ErrorLogDetailRouteComponent() {
  const { id } = Route.useParams();

  return <ErrorLogDetailRoute errorLogId={id} />;
}
